export default "__VITE_PUBLIC_ASSET__4a3c6bd1__"